<div
  [attr.layout-align-items-center]="centered && !stage ? '' : null"
  [attr.layout-align-items-start]="!centered ? '' : null"
  [class.hasStage]="stage"
  [rtTooltip]="offer?.title"
  [rtTooltipEnabled]="!!offer"
  [rtTooltipPosition]="'below'"
  layout-full-height
  layout-horizontal
>
  @if (tooltip) {
    @if (ratingKey) {
      <rt-icon
        [name]="iconMap[ratingKey]"
        [rtTooltip]="getRatingTranslation(ratingKey)"
        [rtTooltipPosition]="'right'"
        [attr.green-icon]="colorize ? isGreen(ratingKey) : null"
        [attr.grey-icon]="colorize ? isGrey(ratingKey) : null"
        [size]="size"
      />
    }
  }

  @if (!tooltip) {
    @if (ratingKey) {
      <rt-icon
        [name]="iconMap[ratingKey]"
        [attr.grey-icon]="colorize ? isGrey(ratingKey) : null"
        [attr.green-icon]="colorize ? isGreen(ratingKey) : null"
        [size]="size"
      />
    }
  }
  <div class="text-wrap">
    @if (hasVariant('hasLabel')) {
      <div class="rating">
        <rt-truncate>
          {{ getRatingTranslation(ratingKey) }}
        </rt-truncate>
      </div>
    }
    @if (stage) {
      <div class="stage">
        <rt-truncate>
          <em>{{ stage }}</em>
        </rt-truncate>
      </div>
    }
  </div>
</div>
